











































































import {Vue, Component, PropSync} from 'vue-property-decorator';
import {TimeoutWings} from "wings-ui-components";
import {dpType} from "@/store/push/application/types";

@Component({
  components: {TimeoutWings}
})
export default class DpSettings extends Vue {
  @PropSync('dpOptions') dp!: dpType;
  @PropSync('filesOptions') files!: { file: File, type: string }[];

  onFilePicked(file: File, type?: string | null) {
    if (!type) return;
    this.files?.push({file: file, type: type});
  }
}
